__turbopack_context__.v({
  "arrow": "Offer50OffBanner-module__oBB6QW__arrow",
  "innerContainer": "Offer50OffBanner-module__oBB6QW__innerContainer",
  "outerContainer": "Offer50OffBanner-module__oBB6QW__outerContainer",
  "textContainer": "Offer50OffBanner-module__oBB6QW__textContainer",
});
